export default __webpack_public_path__ + "static/PromptIconTwo-a98a24adedd8e2b6d147bf7b41113d57.png";